import { ApplicationStatus, ServiceType } from '@prisma/client';
import { AddMerchantApplication } from 'types/graphql';

export const canApproveMerchantApplication = (isAdmin, merchantApplication, merchant) => {
    const hasCorrectRole = isAdmin;

    const hasCorrectApplicationStatus =
        merchantApplication?.status === ApplicationStatus.APPLICATION_ACCEPTED;

    let hasCorrectTerminalIdOrMerchantIdOnMerchant = merchant?.mid !== undefined;

    if (merchantApplication?.serviceRequirements?.service?.serviceType === ServiceType.TERMINAL) {
        hasCorrectTerminalIdOrMerchantIdOnMerchant =
            hasCorrectTerminalIdOrMerchantIdOnMerchant && merchant?.terminalId !== undefined;
    }

    return (
        hasCorrectRole && hasCorrectApplicationStatus && hasCorrectTerminalIdOrMerchantIdOnMerchant
    );
};

export const canFlagErrorIdentifiedMerchantApplication = (isAdmin, merchantApplication, user) => {
    if (!merchantApplication) return false;

    const restrictedStatuses = [
        ApplicationStatus.DRAFT,
        ApplicationStatus.APPLICATION_ACCEPTED,
        ApplicationStatus.ERROR_IDENTIFIED,
        ApplicationStatus.ACTIVE,
        ...(user.id === merchantApplication.authorId
            ? [
                  ApplicationStatus.AWAITING_HARDWARE_DISPATCH,
                  ApplicationStatus.SENT_TO_WORLDPAY_AWAITING_MID,
              ]
            : []),
    ];

    const hasCorrectApplicationStatus = !restrictedStatuses.includes(merchantApplication.status);

    return (
        (isAdmin ||
            ((merchantApplication.partnerId || merchantApplication.partnerOfPartnerId) &&
                user.id === merchantApplication.authorId)) &&
        hasCorrectApplicationStatus
    );
};

export const isApplicationEditable = (merchantApplication: AddMerchantApplication) => {
    return (
        merchantApplication?.status !== ApplicationStatus.DRAFT &&
        merchantApplication?.status != null
    );
};
